import { isLeadPendingProposalElaboration } from '@/components/CloserLeads/closerLeadProposalFlow.util'
import type { CloserLead } from '@/types'

export type ConvertRequestLead = {
  id: string
  dealId?: string | null
  status?: string
  deals?: { id: string; etapa?: string }[]
}

export type ConvertRequestDecision =
  | { action: 'open_modal' }
  | { action: 'resume_proposal' }
  | { action: 'navigate_deal'; dealId: string }
  | { action: 'already_converted' }

/**
 * Decide o que fazer ao pedir conversão / nova negociação.
 * `forceNew` abre o modal mesmo com deal existente (Meus Clientes → Nova negociação).
 */
export function resolveConvertRequestDecision(
  lead: ConvertRequestLead,
  options?: { forceNew?: boolean },
): ConvertRequestDecision {
  if (options?.forceNew) {
    return { action: 'open_modal' }
  }

  const hasDeal = Boolean(lead.dealId || lead.deals?.length)
  if (!hasDeal) {
    return { action: 'open_modal' }
  }

  if (isLeadPendingProposalElaboration(lead as CloserLead)) {
    return { action: 'resume_proposal' }
  }

  if (lead.dealId) {
    return { action: 'navigate_deal', dealId: lead.dealId }
  }

  return { action: 'already_converted' }
}
